import { OrmModel, StringField, NumberField, BooleanField } from 'vuex-orm-decorators'

import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import {
  HubspotExternalIntegration,
  ShopifyExternalIntegration,
  WooCommerceExternalIntegration,
  ZohoExternalIntegration,
} from '@/data/models/domain/externalIntegrations'
import { ExternalIntegrationStatus } from '@/data/models/domain/externalIntegrations/ExternalIntegrationStatus'
import { ExternalIntegrationProvider } from '@/data/models/domain/externalIntegrations/ExternalIntegrationProvider'

const initialStates = new Set([ExternalIntegrationStatus.NOT_CONNECTED, ExternalIntegrationStatus.DISCONNECTED])
const finishedStates = new Set([ExternalIntegrationStatus.ACTIVE])

@OrmModel(modelNames.EXTERNAL_INTEGRATION)
export class ExternalIntegration extends BaseModel {
  public static typeKey = 'provider'

  @StringField('')
  public id: string

  @NumberField(null)
  public connectionId: number | null

  @StringField()
  public provider: ExternalIntegrationProvider

  @StringField(null)
  public externalAccountId: string | null

  @StringField(null)
  public accountName: string | null

  @StringField(null)
  public manageUrl: string | null

  @StringField()
  public status: ExternalIntegrationStatus

  @StringField(null)
  public createdAt: string | null

  @StringField(null)
  public updatedAt: string | null

  @NumberField(null)
  public failedCount: number | null

  @NumberField(null)
  public syncedCount: number | null

  @BooleanField(false)
  public hasError: boolean

  public static types() {
    return {
      [ExternalIntegrationProvider.SHOPIFY]: ShopifyExternalIntegration,
      [ExternalIntegrationProvider.WOO_COMMERCE]: WooCommerceExternalIntegration,
      [ExternalIntegrationProvider.HUBSPOT]: HubspotExternalIntegration,
      [ExternalIntegrationProvider.ZOHO]: ZohoExternalIntegration,
    }
  }

  public isInitialState() {
    return initialStates.has(this.status)
  }

  public isFinishedState() {
    return finishedStates.has(this.status)
  }

  public isSetupState() {
    return !this.isInitialState() && !this.isFinishedState()
  }

  public isErrorState() {
    return this.hasError
  }

  public isActive() {
    return this.status === 'active'
  }

  public isConnecting() {
    return this.status === 'pending'
  }

  public isUnauthorized() {
    return this.status === ExternalIntegrationStatus.UNAUTHORIZED
  }
}

export default ExternalIntegration
